__turbopack_context__.v({
  "menuItem": "DropDownMenu-module-scss-module__39rErG__menuItem",
});
